import { Pipe, PipeTransform } from '@angular/core';
import { userTypeResponse } from 'src/app/shared/constants/response-mapping';

@Pipe({
  name: 'userTypeResponse',
})
export class UserTypeResponsePipe implements PipeTransform {
  transform(value: number | number[]): string {
    if (Array.isArray(value)) {
      const userTypes = value?.map(
        (userTypeValue) => userTypeResponse[userTypeValue] || null
      );
      return userTypes.join(', ');
    }
    return userTypeResponse[value] || null;
  }
}
